const BASE = 'https://roasterycoffee.co.in/wp-content/uploads/2026/02';

export const cities = [
  {
    id: 'hyd',
    name: 'Hyderabad',
    subtitle: 'Where It All Began',
    desc: 'Our home city. The birthplace of Roastery and the city where India first tasted cranberry coffee.',
    img: `${BASE}/1-2-744x1024.png`,
    video: `https://roasterycoffee.co.in/wp-content/uploads/2026/02/ROASTERY_HYD-3.mp4`, 
    cafes: [
      {
        name: 'Banjara Hills',
        tag: 'Flagship · Est. 2017',
        address: '8-2, 418, 287/12, Road No. 14, BNR Colony, Venkat Nagar, Banjara Hills, Hyderabad, Telangana 500034',
        addressShort: 'Road No. 14, Banjara Hills',
        hours: '8:00 AM – 12:00 AM · All days',
        phone: '+91 63095 90610',
        note: 'Heritage bungalow with garden courtyard. First ever Roastery outlet.',
        tags: ['Dine-In', 'Takeaway', 'Beans Available', 'Courtyard', 'Pet Friendly'],
        flagship: true,
        img: `${BASE}/Frame-25.png`,
        mapsUrl: 'https://www.google.com/maps/search/Roastery+Coffee+House+Banjara+Hills+Hyderabad/@17.4231,78.4315,17z',
        embedSrc: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.823!2d78.4289!3d17.4231!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb97b4d0f96931%3A0x1b0d34e59c76c0!2sRoastery%20Coffee%20House%2C%20Banjara%20Hills!5e0!3m2!1sen!2sin!4v1710000000000',
      },
      {
        name: 'Kokapet',
        tag: 'Café · West Hyderabad',
        address: 'Kokapet, Hyderabad, Telangana 500075',
        addressShort: 'Kokapet, Hyderabad',
        hours: '8:00 AM – 11:00 PM · All days',
        phone: '+91 95051 63320',
        note: 'An ode to the Charminar — chessboard floors, terracotta brown walls.',
        tags: ['Dine-In', 'Takeaway', 'Parking Available'],
        flagship: false,
        img: `${BASE}/Frame-26.png`,
        mapsUrl: 'https://www.google.com/maps/search/Roastery+Coffee+House+Kokapet+Hyderabad',
        embedSrc: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3808.0!2d78.3219!3d17.3927!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb93bf3dc52be7%3A0x29b01c0fbd9a6c9e!2sRoastery%20Coffee%20House!5e0!3m2!1sen!2sin!4v1710000000001',
      },
    ],
  },
  {
    id: 'kol',
    name: 'Kolkata',
    subtitle: 'For Long Thoughts and Longer Cups',
    desc: 'Inside the South India Club, Hindustan Park — colonial charm, garden seating, and the city\'s unhurried rhythm.',
    img: `${BASE}/2-1-744x1024.png`,
    video: `https://roasterycoffee.co.in/kolkata/Roasterydp.mp4`, 
    cafes: [
      {
        name: 'Hindustan Park',
        tag: 'Flagship · Inside South India Club',
        address: '70B, Inside South India Club, Hindustan Park, Gariahat, Kolkata, West Bengal 700029',
        addressShort: '70B, Hindustan Park, Gariahat',
        hours: '8:00 AM – 11:00 PM · All days',
        phone: '+91 73306 63045',
        note: 'Historic Calcutta South India Club. Indoor & outdoor garden seating.',
        tags: ['Dine-In', 'Takeaway', 'Beans Available', 'Heritage Venue', 'Garden Seating'],
        flagship: true,
        img: `${BASE}/Frame-43-scaled.png`,
        mapsUrl: 'https://www.google.com/maps/place/Roastery+Coffee+House/@22.5126,88.3633,17z',
        embedSrc: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3685.2!2d88.3633!3d22.5126!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a0277379d4e1d8b%3A0x89d3d016c4c4ad8a!2sRoastery%20Coffee%20House!5e0!3m2!1sen!2sin!4v1710000000002',
      },
    ],
  },
  {
    id: 'del',
    name: 'Delhi',
    subtitle: 'Two Neighbourhoods, One Love for Coffee',
    desc: 'Khan Market in the heart of Delhi, and The Latte Art Atelier in Sarvodaya Enclave — our 10th café in India.',
    img: `${BASE}/6-1-744x1024.png`,
    video: `${BASE}/ROASTERY_DELHI.mp4`, 
    cafes: [
      {
        name: 'Khan Market',
        tag: 'Café · Central Delhi',
        address: 'Khan Market, New Delhi, Delhi 110003',
        addressShort: 'Khan Market, New Delhi',
        hours: '8:00 AM – 11:00 PM · All days',
        phone: '+91 95051 63320',
        note: 'Café in one of Delhi\'s most iconic and expensive retail streets.',
        tags: ['Dine-In', 'Takeaway', 'Beans Available'],
        flagship: true,
        img: `${BASE}/Frame-33.png`,
        mapsUrl: 'https://www.google.com/maps/search/Roastery+Coffee+House+Khan+Market+New+Delhi',
        embedSrc: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3774.2!2d77.2273!3d28.5999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce2b2a4b38b3f%3A0x8e4e84b3d2f78c1b!2sRoastery%20Coffee%20House!5e0!3m2!1sen!2sin!4v1710000000003',
      },
      {
        name: 'Sarvodaya Enclave',
        tag: 'The Latte Art Atelier · 10th Roastery',
        address: 'Sarvodaya Enclave, South Delhi, New Delhi 110017',
        addressShort: 'Sarvodaya Enclave, South Delhi',
        hours: '8:00 AM – 11:00 PM · All days',
        phone: '+91 95051 63320',
        note: '10th Roastery in India — dedicated to the art of the pour.',
        tags: ['Dine-In', 'Takeaway', 'Latte Art Focus', 'Quiet Neighbourhood'],
        flagship: false,
        img: `${BASE}/Frame-36.png`,
        mapsUrl: 'https://www.google.com/maps/search/Roastery+Coffee+House+Sarvodaya+Enclave+Delhi',
        embedSrc: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3503.2!2d77.2073!3d28.5499!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce1e2a4b38b3f%3A0x1234!2sRoastery%20Coffee%20Sarvodaya!5e0!3m2!1sen!2sin!4v1710000000004',
      },
    ],
  },
  {
    id: 'noi',
    name: 'Noida',
    subtitle: 'Built from the Ground Up',
    desc: 'A purpose-built traditional structure at Oxygen Business Park, Sector 144 — sprawling outdoor spaces and large parking.',
    img: `${BASE}/5.png`,
    video: `${BASE}/ROASTERY_NOIDA.mp4`, 
    cafes: [
      {
        name: 'Sector 144, Oxygen Business Park',
        tag: 'Flagship · Purpose-Built',
        address: 'Plot No. BL004, Roastery Street, Near Oxygen Business Park, Sector 144, Noida, UP 201306',
        addressShort: 'Sector 144, Oxygen Business Park',
        hours: '8:00 AM – 11:00 PM · All days',
        phone: '+91 95051 63320',
        note: 'Custom-built traditional bungalow with large outdoor area and event space.',
        tags: ['Dine-In', 'Outdoor Seating', 'Large Parking', 'Events & Bookings'],
        flagship: true,
        img: `${BASE}/Frame-31-scaled.png`,
        mapsUrl: 'https://www.google.com/maps/search/Roastery+Coffee+House+Sector+144+Noida',
        embedSrc: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3506.2!2d77.4173!3d28.5099!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce3b4d0f96931%3A0x1b0d34e59c76c1!2sRoastery%20Coffee%20House%20Noida!5e0!3m2!1sen!2sin!4v1710000000005',
      },
    ],
  },
  {
    id: 'jai',
    name: 'Jaipur',
    subtitle: 'The Pink City Roastery',
    desc: 'Rajasthani craft and warmth woven into our Modern Indian Minimalism — Jaipur\'s Roastery is unlike any other.',
    img: `${BASE}/3-1-744x1024.png`,
    video: `${BASE}/ROASTERY_JAIPUR.mp4`, 
    cafes: [
      {
        name: 'C-Scheme',
        tag: 'Flagship · Jaipur',
        address: 'C-Scheme, Jaipur, Rajasthan 302001',
        addressShort: 'C-Scheme, Jaipur',
        hours: '8:30 AM – 10:30 PM · All days',
        phone: '+91 95051 63320',
        note: 'Rajasthani artisan elements woven into every corner of the space.',
        tags: ['Dine-In', 'Takeaway', 'Artisan Décor', 'Beans Available'],
        flagship: true,
        img: `${BASE}/3-1-744x1024.png`,
        mapsUrl: 'https://www.google.com/maps/search/Roastery+Coffee+House+C+Scheme+Jaipur',
        embedSrc: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3557.2!2d75.8073!3d26.9099!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x396db3a0b3d38b3f%3A0x1234!2sRoastery%20Coffee%20Jaipur!5e0!3m2!1sen!2sin!4v1710000000006',
      },
    ],
  },
  {
    id: 'luc',
    name: 'Lucknow',
    subtitle: 'Nawabi Coffee Culture',
    desc: 'In the city of Nawabs — Gomti Nagar\'s Roastery pairs specialty coffee with Lucknow\'s legendary hospitality.',
    img: `${BASE}/4-1-744x1024.png`,
    video: `https://roasterycoffee.co.in/wp-content/uploads/2026/02/final-landscape-logo.mp4`, 
    cafes: [
      {
        name: 'Gomti Nagar',
        tag: 'Flagship · Lucknow',
        address: 'Vibhuti Khand, Gomti Nagar, Lucknow, Uttar Pradesh 226010',
        addressShort: 'Vibhuti Khand, Gomti Nagar',
        hours: '8:00 AM – 11:00 PM · All days',
        phone: '+91 95051 63320',
        note: 'Full food menu with Lucknawi-inspired additions.',
        tags: ['Dine-In', 'Takeaway', 'Full Food Menu', 'Beans Available'],
        flagship: true,
        img: `${BASE}/Frame-45.png`,
        mapsUrl: 'https://www.google.com/maps/search/Roastery+Coffee+House+Gomti+Nagar+Lucknow',
        embedSrc: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3560.2!2d80.9673!3d26.8699!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3999f1e5a4b38b3f%3A0x1234!2sRoastery%20Coffee%20Lucknow!5e0!3m2!1sen!2sin!4v1710000000007',
      },
    ],
  },
];